import { jsx as ge } from "react/jsx-runtime";
import * as n from "react";
import { d as _, k as be, y as Se, _ as q, z as ne, n as L, v as pe, c as z, q as ie, g as $e, m as ye, A as we, o as Ce, B as xe, u as j, D as Ne, E as Oe } from "./CSSMotionList.js";
import { _ as Q } from "./extends.js";
import { u as Re, a as Me } from "./useSize.js";
import { o as Ie } from "./omit.js";
import { u as Ee } from "./useId.js";
var k = function(t, i) {
  if (!t) return null;
  var a = {
    left: t.offsetLeft,
    right: t.parentElement.clientWidth - t.clientWidth - t.offsetLeft,
    width: t.clientWidth,
    top: t.offsetTop,
    bottom: t.parentElement.clientHeight - t.clientHeight - t.offsetTop,
    height: t.clientHeight
  };
  return i ? {
    left: 0,
    right: 0,
    width: 0,
    top: a.top,
    bottom: a.bottom,
    height: a.height
  } : {
    left: a.left,
    right: a.right,
    width: a.width,
    top: 0,
    bottom: 0,
    height: 0
  };
}, w = function(t) {
  return t !== void 0 ? "".concat(t, "px") : void 0;
};
function je(e) {
  var t = e.prefixCls, i = e.containerRef, a = e.value, o = e.getValueIndex, s = e.motionName, S = e.onMotionStart, h = e.onMotionEnd, b = e.direction, C = e.vertical, d = C === void 0 ? !1 : C, N = n.useRef(null), P = n.useState(a), O = _(P, 2), v = O[0], R = O[1], M = function(E) {
    var x, V = o(E), y = (x = i.current) === null || x === void 0 ? void 0 : x.querySelectorAll(".".concat(t, "-item"))[V];
    return (y == null ? void 0 : y.offsetParent) && y;
  }, D = n.useState(null), m = _(D, 2), r = m[0], I = m[1], T = n.useState(null), g = _(T, 2), l = g[0], H = g[1];
  be(function() {
    if (v !== a) {
      var c = M(v), E = M(a), x = k(c, d), V = k(E, d);
      R(a), I(x), H(V), c && E ? S() : h();
    }
  }, [a]);
  var p = n.useMemo(function() {
    if (d) {
      var c;
      return w((c = r == null ? void 0 : r.top) !== null && c !== void 0 ? c : 0);
    }
    return w(b === "rtl" ? -(r == null ? void 0 : r.right) : r == null ? void 0 : r.left);
  }, [d, b, r]), $ = n.useMemo(function() {
    if (d) {
      var c;
      return w((c = l == null ? void 0 : l.top) !== null && c !== void 0 ? c : 0);
    }
    return w(b === "rtl" ? -(l == null ? void 0 : l.right) : l == null ? void 0 : l.left);
  }, [d, b, l]), K = function() {
    return d ? {
      transform: "translateY(var(--thumb-start-top))",
      height: "var(--thumb-start-height)"
    } : {
      transform: "translateX(var(--thumb-start-left))",
      width: "var(--thumb-start-width)"
    };
  }, A = function() {
    return d ? {
      transform: "translateY(var(--thumb-active-top))",
      height: "var(--thumb-active-height)"
    } : {
      transform: "translateX(var(--thumb-active-left))",
      width: "var(--thumb-active-width)"
    };
  }, F = function() {
    I(null), H(null), h();
  };
  return !r || !l ? null : /* @__PURE__ */ n.createElement(Se, {
    visible: !0,
    motionName: s,
    motionAppear: !0,
    onAppearStart: K,
    onAppearActive: A,
    onVisibleChanged: F
  }, function(c, E) {
    var x = c.className, V = c.style, y = q(q({}, V), {}, {
      "--thumb-start-left": p,
      "--thumb-start-width": w(r == null ? void 0 : r.width),
      "--thumb-active-left": $,
      "--thumb-active-width": w(l == null ? void 0 : l.width),
      "--thumb-start-top": p,
      "--thumb-start-height": w(r == null ? void 0 : r.height),
      "--thumb-active-top": $,
      "--thumb-active-height": w(l == null ? void 0 : l.height)
    }), X = {
      ref: ne(N, E),
      style: y,
      className: L("".concat(t, "-thumb"), x)
    };
    return process.env.NODE_ENV === "test" && (X["data-test-style"] = JSON.stringify(y)), /* @__PURE__ */ n.createElement("div", X);
  });
}
var Pe = ["prefixCls", "direction", "vertical", "options", "disabled", "defaultValue", "value", "name", "onChange", "className", "motionName"];
function De(e) {
  if (typeof e.title < "u")
    return e.title;
  if (ie(e.label) !== "object") {
    var t;
    return (t = e.label) === null || t === void 0 ? void 0 : t.toString();
  }
}
function He(e) {
  return e.map(function(t) {
    if (ie(t) === "object" && t !== null) {
      var i = De(t);
      return q(q({}, t), {}, {
        title: i
      });
    }
    return {
      label: t == null ? void 0 : t.toString(),
      title: t == null ? void 0 : t.toString(),
      value: t
    };
  });
}
var Ae = function(t) {
  var i = t.prefixCls, a = t.className, o = t.disabled, s = t.checked, S = t.label, h = t.title, b = t.value, C = t.name, d = t.onChange, N = t.onFocus, P = t.onBlur, O = t.onKeyDown, v = t.onKeyUp, R = t.onMouseDown, M = function(m) {
    o || d(m, b);
  };
  return /* @__PURE__ */ n.createElement("label", {
    className: L(a, z({}, "".concat(i, "-item-disabled"), o)),
    onMouseDown: R
  }, /* @__PURE__ */ n.createElement("input", {
    name: C,
    className: "".concat(i, "-item-input"),
    type: "radio",
    disabled: o,
    checked: s,
    onChange: M,
    onFocus: N,
    onBlur: P,
    onKeyDown: O,
    onKeyUp: v
  }), /* @__PURE__ */ n.createElement("div", {
    className: "".concat(i, "-item-label"),
    title: h,
    "aria-selected": s
  }, S));
}, oe = /* @__PURE__ */ n.forwardRef(function(e, t) {
  var i, a, o = e.prefixCls, s = o === void 0 ? "rc-segmented" : o, S = e.direction, h = e.vertical, b = e.options, C = b === void 0 ? [] : b, d = e.disabled, N = e.defaultValue, P = e.value, O = e.name, v = e.onChange, R = e.className, M = R === void 0 ? "" : R, D = e.motionName, m = D === void 0 ? "thumb-motion" : D, r = pe(e, Pe), I = n.useRef(null), T = n.useMemo(function() {
    return ne(I, t);
  }, [I, t]), g = n.useMemo(function() {
    return He(C);
  }, [C]), l = Re((i = g[0]) === null || i === void 0 ? void 0 : i.value, {
    value: P,
    defaultValue: N
  }), H = _(l, 2), p = H[0], $ = H[1], K = n.useState(!1), A = _(K, 2), F = A[0], c = A[1], E = function(f, B) {
    $(B), v == null || v(B);
  }, x = Ie(r, ["children"]), V = n.useState(!1), y = _(V, 2), X = y[0], U = y[1], le = n.useState(!1), G = _(le, 2), se = G[0], Z = G[1], ce = function() {
    Z(!0);
  }, de = function() {
    Z(!1);
  }, ue = function() {
    U(!1);
  }, me = function(f) {
    f.key === "Tab" && U(!0);
  }, Y = function(f) {
    var B = g.findIndex(function(he) {
      return he.value === p;
    }), J = g.length, fe = (B + f + J) % J, W = g[fe];
    W && ($(W.value), v == null || v(W.value));
  }, ve = function(f) {
    switch (f.key) {
      case "ArrowLeft":
      case "ArrowUp":
        Y(-1);
        break;
      case "ArrowRight":
      case "ArrowDown":
        Y(1);
        break;
    }
  };
  return /* @__PURE__ */ n.createElement("div", Q({
    role: "radiogroup",
    "aria-label": "segmented control",
    tabIndex: d ? void 0 : 0
  }, x, {
    className: L(s, (a = {}, z(a, "".concat(s, "-rtl"), S === "rtl"), z(a, "".concat(s, "-disabled"), d), z(a, "".concat(s, "-vertical"), h), a), M),
    ref: T
  }), /* @__PURE__ */ n.createElement("div", {
    className: "".concat(s, "-group")
  }, /* @__PURE__ */ n.createElement(je, {
    vertical: h,
    prefixCls: s,
    value: p,
    containerRef: I,
    motionName: "".concat(s, "-").concat(m),
    direction: S,
    getValueIndex: function(f) {
      return g.findIndex(function(B) {
        return B.value === f;
      });
    },
    onMotionStart: function() {
      c(!0);
    },
    onMotionEnd: function() {
      c(!1);
    }
  }), g.map(function(u) {
    var f;
    return /* @__PURE__ */ n.createElement(Ae, Q({}, u, {
      name: O,
      key: u.value,
      prefixCls: s,
      className: L(u.className, "".concat(s, "-item"), (f = {}, z(f, "".concat(s, "-item-selected"), u.value === p && !F), z(f, "".concat(s, "-item-focused"), se && X && u.value === p), f)),
      checked: u.value === p,
      onChange: E,
      onFocus: ce,
      onBlur: de,
      onKeyDown: ve,
      onKeyUp: me,
      onMouseDown: ue,
      disabled: !!d || !!u.disabled
    }));
  })));
});
process.env.NODE_ENV !== "production" && (oe.displayName = "Segmented");
var Ve = oe;
function ee(e, t) {
  return {
    [`${e}, ${e}:hover, ${e}:focus`]: {
      color: t.colorTextDisabled,
      cursor: "not-allowed"
    }
  };
}
function te(e) {
  return {
    backgroundColor: e.itemSelectedBg,
    boxShadow: e.boxShadowTertiary
  };
}
const _e = Object.assign({
  overflow: "hidden"
}, we), Be = (e) => {
  const {
    componentCls: t
  } = e, i = e.calc(e.controlHeight).sub(e.calc(e.trackPadding).mul(2)).equal(), a = e.calc(e.controlHeightLG).sub(e.calc(e.trackPadding).mul(2)).equal(), o = e.calc(e.controlHeightSM).sub(e.calc(e.trackPadding).mul(2)).equal();
  return {
    [t]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, Ce(e)), {
      display: "inline-block",
      padding: e.trackPadding,
      color: e.itemColor,
      background: e.trackBg,
      borderRadius: e.borderRadius,
      transition: `all ${e.motionDurationMid} ${e.motionEaseInOut}`
    }), xe(e)), {
      [`${t}-group`]: {
        position: "relative",
        display: "flex",
        alignItems: "stretch",
        justifyItems: "flex-start",
        flexDirection: "row",
        width: "100%"
      },
      // RTL styles
      [`&${t}-rtl`]: {
        direction: "rtl"
      },
      [`&${t}-vertical`]: {
        [`${t}-group`]: {
          flexDirection: "column"
        },
        [`${t}-thumb`]: {
          width: "100%",
          height: 0,
          padding: `0 ${j(e.paddingXXS)}`
        }
      },
      // block styles
      [`&${t}-block`]: {
        display: "flex"
      },
      [`&${t}-block ${t}-item`]: {
        flex: 1,
        minWidth: 0
      },
      // item styles
      [`${t}-item`]: {
        position: "relative",
        textAlign: "center",
        cursor: "pointer",
        transition: `color ${e.motionDurationMid} ${e.motionEaseInOut}`,
        borderRadius: e.borderRadiusSM,
        // Fix Safari render bug
        // https://github.com/ant-design/ant-design/issues/45250
        transform: "translateZ(0)",
        "&-selected": Object.assign(Object.assign({}, te(e)), {
          color: e.itemSelectedColor
        }),
        "&-focused": Object.assign({}, Ne(e)),
        "&::after": {
          content: '""',
          position: "absolute",
          zIndex: -1,
          width: "100%",
          height: "100%",
          top: 0,
          insetInlineStart: 0,
          borderRadius: "inherit",
          opacity: 0,
          transition: `opacity ${e.motionDurationMid}`,
          // This is mandatory to make it not clickable or hoverable
          // Ref: https://github.com/ant-design/ant-design/issues/40888
          pointerEvents: "none"
        },
        [`&:hover:not(${t}-item-selected):not(${t}-item-disabled)`]: {
          color: e.itemHoverColor,
          "&::after": {
            opacity: 1,
            backgroundColor: e.itemHoverBg
          }
        },
        [`&:active:not(${t}-item-selected):not(${t}-item-disabled)`]: {
          color: e.itemHoverColor,
          "&::after": {
            opacity: 1,
            backgroundColor: e.itemActiveBg
          }
        },
        "&-label": Object.assign({
          minHeight: i,
          lineHeight: j(i),
          padding: `0 ${j(e.segmentedPaddingHorizontal)}`
        }, _e),
        // syntactic sugar to add `icon` for Segmented Item
        "&-icon + *": {
          marginInlineStart: e.calc(e.marginSM).div(2).equal()
        },
        "&-input": {
          position: "absolute",
          insetBlockStart: 0,
          insetInlineStart: 0,
          width: 0,
          height: 0,
          opacity: 0,
          pointerEvents: "none"
        }
      },
      // thumb styles
      [`${t}-thumb`]: Object.assign(Object.assign({}, te(e)), {
        position: "absolute",
        insetBlockStart: 0,
        insetInlineStart: 0,
        width: 0,
        height: "100%",
        padding: `${j(e.paddingXXS)} 0`,
        borderRadius: e.borderRadiusSM,
        transition: `transform ${e.motionDurationSlow} ${e.motionEaseInOut}, height ${e.motionDurationSlow} ${e.motionEaseInOut}`,
        [`& ~ ${t}-item:not(${t}-item-selected):not(${t}-item-disabled)::after`]: {
          backgroundColor: "transparent"
        }
      }),
      // size styles
      [`&${t}-lg`]: {
        borderRadius: e.borderRadiusLG,
        [`${t}-item-label`]: {
          minHeight: a,
          lineHeight: j(a),
          padding: `0 ${j(e.segmentedPaddingHorizontal)}`,
          fontSize: e.fontSizeLG
        },
        [`${t}-item, ${t}-thumb`]: {
          borderRadius: e.borderRadius
        }
      },
      [`&${t}-sm`]: {
        borderRadius: e.borderRadiusSM,
        [`${t}-item-label`]: {
          minHeight: o,
          lineHeight: j(o),
          padding: `0 ${j(e.segmentedPaddingHorizontalSM)}`
        },
        [`${t}-item, ${t}-thumb`]: {
          borderRadius: e.borderRadiusXS
        }
      }
    }), ee(`&-disabled ${t}-item`, e)), ee(`${t}-item-disabled`, e)), {
      // transition effect when `appear-active`
      [`${t}-thumb-motion-appear-active`]: {
        transition: `transform ${e.motionDurationSlow} ${e.motionEaseInOut}, width ${e.motionDurationSlow} ${e.motionEaseInOut}`,
        willChange: "transform, width"
      },
      [`&${t}-shape-round`]: {
        borderRadius: 9999,
        [`${t}-item, ${t}-thumb`]: {
          borderRadius: 9999
        }
      }
    })
  };
}, ze = (e) => {
  const {
    colorTextLabel: t,
    colorText: i,
    colorFillSecondary: a,
    colorBgElevated: o,
    colorFill: s,
    lineWidthBold: S,
    colorBgLayout: h
  } = e;
  return {
    trackPadding: S,
    trackBg: h,
    itemColor: t,
    itemHoverColor: i,
    itemHoverBg: a,
    itemSelectedBg: o,
    itemActiveBg: s,
    itemSelectedColor: i
  };
}, Te = $e("Segmented", (e) => {
  const {
    lineWidth: t,
    calc: i
  } = e, a = ye(e, {
    segmentedPaddingHorizontal: i(e.controlPaddingHorizontal).sub(t).equal(),
    segmentedPaddingHorizontalSM: i(e.controlPaddingHorizontalSM).sub(t).equal()
  });
  return [Be(a)];
}, ze);
var ae = function(e, t) {
  var i = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (i[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var o = 0, a = Object.getOwnPropertySymbols(e); o < a.length; o++)
    t.indexOf(a[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[o]) && (i[a[o]] = e[a[o]]);
  return i;
};
function Ke(e) {
  return typeof e == "object" && !!(e != null && e.icon);
}
const Fe = /* @__PURE__ */ n.forwardRef((e, t) => {
  const i = Ee(), {
    prefixCls: a,
    className: o,
    rootClassName: s,
    block: S,
    options: h = [],
    size: b = "middle",
    style: C,
    vertical: d,
    shape: N = "default",
    name: P = i
  } = e, O = ae(e, ["prefixCls", "className", "rootClassName", "block", "options", "size", "style", "vertical", "shape", "name"]), {
    getPrefixCls: v,
    direction: R,
    className: M,
    style: D
  } = Oe("segmented"), m = v("segmented", a), [r, I, T] = Te(m), g = Me(b), l = n.useMemo(() => h.map(($) => {
    if (Ke($)) {
      const {
        icon: K,
        label: A
      } = $, F = ae($, ["icon", "label"]);
      return Object.assign(Object.assign({}, F), {
        label: /* @__PURE__ */ n.createElement(n.Fragment, null, /* @__PURE__ */ n.createElement("span", {
          className: `${m}-item-icon`
        }, K), A && /* @__PURE__ */ n.createElement("span", null, A))
      });
    }
    return $;
  }), [h, m]), H = L(o, s, M, {
    [`${m}-block`]: S,
    [`${m}-sm`]: g === "small",
    [`${m}-lg`]: g === "large",
    [`${m}-vertical`]: d,
    [`${m}-shape-${N}`]: N === "round"
  }, I, T), p = Object.assign(Object.assign({}, D), C);
  return r(/* @__PURE__ */ n.createElement(Ve, Object.assign({}, O, {
    name: P,
    className: H,
    style: p,
    options: l,
    ref: t,
    prefixCls: m,
    direction: R,
    vertical: d
  })));
}), re = Fe;
process.env.NODE_ENV !== "production" && (re.displayName = "Segmented");
const Le = {
  sm: "small",
  md: "middle",
  lg: "large"
}, Ye = ({ size: e = "md", ...t }) => /* @__PURE__ */ ge(re, { size: Le[e], ...t });
export {
  Ye as S
};
